import { useEffect } from 'react';
import { RootState } from 'app/root-reducer';
import { useDispatch } from "react-redux";
import { SelectedProgramContextTab, getProgramContextTabParamRoute, setSelectedProgramContextTab, getProgramContextTabRouteParam, programContextPagesRoutes, programContextPageRoute } from "features/selected-context";
import { useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from 'components/Loading';

const isCurrentPath = (pathname: string, route: string) => {
  const endSlashPosition = route !== '/' && route.endsWith('/') ? route.length - 1 : route.length;
  return pathname === route || (pathname.startsWith(route) && pathname.charAt(endSlashPosition) === '/');
};

const contextCurrentTab = (pathname: string, contextSelectedId?: string) => {
  if (contextSelectedId) {
    for (const pg of programContextPagesRoutes) {
      const route = pg.route.replace(':programId', contextSelectedId);
      const endSlashPosition = route !== '/' && route.endsWith('/') ? route.length - 1 : route.length;
      if (pathname === route || (pathname.startsWith(route) && pathname.charAt(endSlashPosition) === '/')) return pg;
    }
  }
  return null;
};

const isProgramContextPagePath = (pathname: string, contextSelectedId: string) => {
  const contextPageRoute = programContextPageRoute.replace(':programId', contextSelectedId);
  return isCurrentPath(pathname, contextPageRoute);
};

const JobSeekerProgramContextNavbar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { tab, selectedId: programContextSelectedId, data: { programDataIsLoading } } = useAppSelector((state: RootState) => state.selectedContext.programContext);

  const { pathname } = useLocation();
  const programContextSelectedTab = contextCurrentTab(pathname, programContextSelectedId);

  useEffect(() => {
    if (programContextSelectedTab?.tab) {
      dispatch(setSelectedProgramContextTab(programContextSelectedTab.tab));
    } else if (programContextSelectedId && isProgramContextPagePath(pathname, programContextSelectedId)) {
      const defaultPageParam = getProgramContextTabRouteParam(undefined)
      history.replace(`${programContextPageRoute.replace(':programId', programContextSelectedId)}/${defaultPageParam}`);
    }
  }, [history, programContextSelectedTab?.tab, pathname, programContextSelectedId, dispatch]);

  const activeTab = tab &&
    [SelectedProgramContextTab.GroupHub, SelectedProgramContextTab.GroupProductsAndServices, SelectedProgramContextTab.GroupEvents, SelectedProgramContextTab.GroupMembers, SelectedProgramContextTab.GroupAbout].includes(tab) ?
    tab :
    getProgramContextTabParamRoute(undefined);

  return (
    <>
      {programDataIsLoading && <Loading useLayout={false} />}
      <div className="sections">
        {programContextSelectedId && programContextPagesRoutes.map(({ tab, route }) => (
          <button
            key={tab}
            className={`btn ${activeTab === tab ? 'selected' : ''}`}
            onClick={() => history.push(route.replace(':programId', programContextSelectedId))}
          >
            {tab}
          </button>
        ))}
      </div>
    </>
  );
};

export default JobSeekerProgramContextNavbar;
